import { render, staticRenderFns } from "./ModalAddContact.vue?vue&type=template&id=5e8de545&"
import script from "./ModalAddContact.vue?vue&type=script&lang=js&"
export * from "./ModalAddContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e8de545')) {
      api.createRecord('5e8de545', component.options)
    } else {
      api.reload('5e8de545', component.options)
    }
    module.hot.accept("./ModalAddContact.vue?vue&type=template&id=5e8de545&", function () {
      api.rerender('5e8de545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/notifications/ModalAddContact.vue"
export default component.exports